import { create } from 'zustand';

/**
 * Whether the help drawer is open, and on which guide.
 *
 * Lifted out of the component for the same reason as the assistant panel: several things need to
 * open it and none of them own it. A guidance suggestion ("no doctor is assigned to a chair") should
 * open the guide that fixes it; the assistant should open the guide it just cited; the header button
 * should open the one for the current page. All three are "open help at X", from different corners
 * of the app.
 */
interface HelpState {
  open: boolean;
  /** The guide being read, or null for the search view. */
  slug: string | null;
  /** Where the reader came from, so closing returns them there rather than to a blank panel. */
  openHelp: (slug?: string | null) => void;
  close: () => void;
  show: (slug: string | null) => void;
}

export const useHelpStore = create<HelpState>((set) => ({
  open: false,
  slug: null,
  openHelp: (slug = null) => set({ open: true, slug }),
  close: () => set({ open: false }),
  show: (slug) => set({ slug }),
}));
